import { render } from "./singleUserDetail.vue?vue&type=template&id=a871bd74&scoped=true"
import script from "./singleUserDetail.vue?vue&type=script&lang=js"
export * from "./singleUserDetail.vue?vue&type=script&lang=js"

import "./singleUserDetail.vue?vue&type=style&index=0&id=a871bd74&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a871bd74"]])

export default __exports__